<template lang="pug">
  .account-step
    //- if authenticated
    //- show filled form
    //- otherwise let user decide
    //- if he wants to login or proceed as guest

    //- NOTE
    //- temporary. See TODO below

    //- TODO
    //- Authenticate.mb-8(
    //-   v-if="! isAuthenticated && type === 'member'"
    //-   :registration="false"
    //-   :default-tab="tab"
    //-   :default-email="form.email"
    //- )
    //-   template(slot="prepend-tab")
    //-     li
    //-       a(href="#" @click.stop.prevent="type = 'guest'") Als Gast fortfahren

    .authentication-form
      .panel.mb-8
        .tabs(v-if="! isAuthenticated && type === 'guest'")
          ul
            li.is-active
              a(href="#" @click.stop.prevent="type = 'guest'") Als Gast fortfahren
            li
              a(href="#" @click.stop.prevent="tab = 'signin'; type = 'member'") Anmelden
        .box
          MemberForm(:form="form")
          hr.my-4
          // TODO: multiple addresses / add address
          AddressForm(:form="form.billing_address" label="Rechnungsadresse")
</template>

<script>
import { mapGetters } from 'vuex';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';
import AddressForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm';
import MemberForm from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/MemberForm';

export default {
    name: 'AccountStep',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        type: 'guest',
        tab: 'signin'
    }),
    components: {
        Authenticate,
        MemberForm,
        AddressForm
    },
    computed: {
        ...mapGetters({
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated'
        })
    },
    mounted() {
        if (this.isAuthenticated && this.member) {
            this.type = 'member'; // otherwise 'guest' (default)
        }
    }
};
</script>

<style lang="sass" scoped></style>
